import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Select } from 'antd';
import LazyLoadSelect from "../../components/LazyLoadSelect";
const CustomerGroupSelect = ({ tenantId, disabled = false, allowClear = true, value, placeholder = "Select Customer Group", onChange, onCustomerGroupSelected }) => {
    const optionsRenderer = (customerGroups) => {
        return customerGroups.map(customerGroup => (_jsx(Select.Option, { value: customerGroup.id, filter: customerGroup.name, children: customerGroup.name }, customerGroup.id)));
    };
    const onSelected = (customerGroup) => {
        onCustomerGroupSelected && onCustomerGroupSelected(customerGroup);
        onChange && onChange(customerGroup?.id);
    };
    return (_jsx(LazyLoadSelect, { style: { width: '100%' }, disabled: disabled, allowClear: allowClear, placeholder: placeholder, url: "/admin/v1/customers/groups", tenantId: tenantId, notFoundMessage: "No customer groups found", searchKey: "nameLike", queryParams: {
            enabled: true
        }, onChange: onChange, onSelected: onSelected, optionsRenderer: optionsRenderer, value: value }));
};
export default CustomerGroupSelect;
